import type { FeatureFlag, RelyingPartySettingType } from '@/shared/lib/types/relyingParty';
import { create } from 'zustand';

export interface FeatureFlags {
  [FeatureFlag.SHOW_CHART_REVIEW]: boolean;
  [FeatureFlag.SHOW_AI_NOTES_SUMMARY]: boolean;
  [FeatureFlag.PLAYFUL_FEEDBACK]: boolean;
  [FeatureFlag.AI_SEARCH]: boolean;
  [FeatureFlag.ENGAGEMENT_TIME_TRACKING]: boolean;
}

export interface FeatureFlagStore {
  flags: FeatureFlags;
  initializeFlags: (settings: RelyingPartySettingType) => void;
  isFeatureEnabled: (flagName: FeatureFlag) => boolean;
}

export const useFeatureFlagStore = create<FeatureFlagStore>((set, get) => ({
  flags: {
    chartReview: false,
    aiNotesSummary: false,
    playfulFeedbackEnabled: false,
    aiSearch: false,
    engagementTimeTracking: false
  },
  initializeFlags: (settings: RelyingPartySettingType) =>
    set({
      flags: {
        chartReview:
          settings?.AdditionalFeatures?.chartReview !== undefined
            ? settings?.AdditionalFeatures?.chartReview === 'true' || settings?.AdditionalFeatures?.chartReview === true
            : true,
        aiNotesSummary: settings?.AdditionalFeatures?.aiNotesSummary === 'true' || settings?.AdditionalFeatures?.aiNotesSummary === true,
        playfulFeedbackEnabled:
          settings?.AdditionalFeatures?.playfulFeedbackEnabled === 'true' || settings?.AdditionalFeatures?.playfulFeedbackEnabled === true,
        aiSearch: settings?.AdditionalFeatures?.aiSearch === 'true' || settings?.AdditionalFeatures?.aiSearch === true,
        engagementTimeTracking:
          settings?.AdditionalFeatures?.engagementTimeTracking === 'true' || settings?.AdditionalFeatures?.engagementTimeTracking === true
      }
    }),
  isFeatureEnabled: flagName => get().flags[flagName]
}));
